module.exports = __webpack_public_path__ + "img/6c7fe515f4530c67903a5c47b6dae9b6.png";